import { lazy } from 'react'
import { Navigate, Route } from 'react-router'
import { SEGMENTS } from '@/app/router/routes'
import RoutesWithNotFound from '@/shared/components/routes-with-not-found'
import LayoutAccount from '../components/layout-account'

const LazyPageAccount = lazy(async () => await import('../pages/account'))
const LazyPageSecurity = lazy(async () => await import('../pages/security'))

const RouterAccounts = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<LayoutAccount />}>
        <Route path="/" element={<Navigate to={SEGMENTS.account.general} />} />
        <Route path={SEGMENTS.account.general} element={<LazyPageAccount />} />
        <Route path={SEGMENTS.account.security} element={<LazyPageSecurity />} />
      </Route>
    </RoutesWithNotFound>
  )
}

export default RouterAccounts
